import { Input, Autocomplete, AutocompleteItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters = {}, filterOptions }) => {
    const { categories } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <Input
                label="Nama"
                placeholder="Cari nama..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({ ...prev, name: val }))
                }
                variant="flat"
                isClearable
            />
            <Autocomplete
                label="Kategori"
                placeholder="Pilih Kategori"
                selectedKey={
                    pending.master_cash_category_id
                        ? String(pending.master_cash_category_id)
                        : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        master_cash_category_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {(categories || []).map((cat) => (
                    <AutocompleteItem key={String(cat.value)} value={cat.value}>
                        {cat.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>
        </FilterCard>
    );
};

export default FilterData;
